import { initializeApp } from 'firebase/app'
import {
  isSupported,
  getMessaging,
  getToken,
  onMessage as onFirebaseMessage,
} from 'firebase/messaging'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)

let messaging = null

;(async function() {
  if (await isSupported()) messaging = getMessaging(app)
})()

export const requestFirebaseNotificationPermission = async () => {
  if (!(await isSupported())) return

  return new Promise((resolve, reject) => {
    if (messaging) {
      Notification.requestPermission()
        .then(permission => {
          if (permission === 'granted') {
            getFirebaseToken()
              .then(firebaseToken => {
                resolve(firebaseToken)
              })
              .catch(reject)
          }
        })
        .catch(reject)
    } else {
      reject('Firebase is not supported in this browser')
    }
  })
}

export function getFirebaseToken() {
  if (messaging)
    return getToken(messaging, {
      vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY,
    })
  return new Promise((resolve, reject) => {
    reject('Firebase is not supported in this browser')
  })
}

export async function onMessage(cb) {
  if (!(await isSupported())) return

  onFirebaseMessage(messaging, cb)
}

export { messaging }
